import styled from '@emotion/styled';
import { mediaQueries, remCalc, palette, font } from '../../css';
import { StyledButton } from '../Button/Button.css';

const StyledSharebar = styled('div')(() => ({
    position: 'relative',
    display: 'inline-block',
    width: remCalc(220),
    textAlign: 'center',
    color: palette('white'),
    cursor: 'pointer',

    [StyledButton]: {
        fontWeight: font.weight.medium,
        paddingTop: remCalc(15),
        paddingBottom: remCalc(15),
    },
}));

const StyledIcons = styled('div')(
    ({ theme }) => ({
        position: 'absolute',
        top: 0,
        transition: 'all .25s ease-in',
        left: 0,
        right: 0,
        opacity: 0,
        display: 'flex',
        justifyContent: 'center',
        pointerEvents: 'none',
        backgroundColor: theme.backgroundColor,
        transform: 'translateY(0) scale(.7)',
    }),
    ({ expanded }) =>
        expanded
            ? {
                  pointerEvents: 'all',
                  padding: remCalc(10),
                  transform: `translateY(${remCalc(-80)}) scale(1)`,
                  opacity: 1,
              }
            : {},
);

const StyledLink = styled('a')(
    () => ({
        transition: 'background-color .50s ease-out, border-color .25s ease-out, transform .35s ease-out',
        width: remCalc(40),
        height: remCalc(40),
        borderRadius: '100%',
        border: '1px solid #fff',
        textAlign: 'center',
        '&:first-child': {
            margin: 0,
        },
        marginLeft: remCalc(10),
    }),
    ({ provider }) => {
        let providerStyle = {};
        if (provider === 'facebook') {
            providerStyle['&:hover,&:focus'] = {
                backgroundColor: '#325B98',
                borderColor: '#325B98',
            };
        } else if (provider === 'twitter') {
            providerStyle['&:hover,&:focus'] = {
                backgroundColor: '#00ADEF',
                borderColor: '#00ADEF',
            };
        } else if (provider === 'whatsapp') {
            providerStyle = {
                display: 'block',
                '&:hover,&:focus': {
                    backgroundColor: '#4dc658',
                    borderColor: '#4dc658',
                },
                [mediaQueries.medium]: {
                    display: 'none',
                },
            };
        }
        return providerStyle;
    },
);

const StyledImage = styled('img')(() => ({
    width: 'auto',
    height: remCalc(20),
    marginTop: remCalc(10),
}));

const StyledTriangle = styled('div')(({ theme }) => ({
    width: remCalc(15),
    height: remCalc(15),
    position: 'absolute',
    left: 0,
    right: 0,
    margin: '0 auto',
    bottom: remCalc(-15),
    '::before': {
        content: "''",
        position: 'absolute',
        top: 0,
        left: 0,
        fontSize: 0,
        lineHeight: 0,
        borderTop: theme.borderTop,
        borderLeft: `${remCalc(10)} solid transparent`,
        borderRight: `${remCalc(10)} solid transparent`,
    },
}));

export { StyledIcons, StyledImage, StyledLink, StyledSharebar, StyledTriangle };
